<template>
	<FormTitle
		v-if="title"
		:text="title"
		:required="required"
		:title-active="titleActive"
		:error="errorText ? true : false"
		:disabled="disabled"
		:kizuna-type="kizunaType"
	/>

	<div class="form_group" :class="[formClass, { error: errorClass }]">
		<div :class="formClass">
			<vue-date-picker
				v-model="date"
				locale="jp"
				class="w-full"
				month-picker
				auto-apply
				format="yyyy/MM"
				:disabled="disabled"
			/>
		</div>
	</div>
	<!-- 補足説明 -->
	<ErrorText :text="errorText" />
</template>

<script setup>
// その他
import ErrorText from "@/components/atoms/ErrorText.vue";
import FormTitle from "@/components/atoms/FormTitle.vue";
import { computed, onMounted, ref, watch } from "vue";

/* ---------------------------------------------------------------------------
	emits
---------------------------------------------------------------------------- */
const emit = defineEmits(["update:modelValue"]);
/* ---------------------------------------------------------------------------
	props
---------------------------------------------------------------------------- */
const props = defineProps({
	modelValue: String,
	title: String,
	formClass: [String, Array],
	disabled: Boolean,
	required: Boolean,
	errorText: String,
	kizunaType: Number
});
/* ---------------------------------------------------------------------------
data
---------------------------------------------------------------------------- */
const titleActive = ref(false);
const errorClass = ref("");
const monthValue = ref({ month: "", year: "" });

/* ---------------------------------------------------------------------------
	computed
---------------------------------------------------------------------------- */
const date = computed({
	get: () => monthFormat(props.modelValue),
	set: val => emit("update:modelValue", generationFormat(val))
});
/* ---------------------------------------------------------------------------
	modelValueの値を監視
---------------------------------------------------------------------------- */
watch(
	() => date,
	(newValue, oldValue) => {
		enteredOrNotCheck(newValue);
	}
);
/* ---------------------------------------------------------------------------
	入力項目の判定
---------------------------------------------------------------------------- */
function enteredOrNotCheck(value) {
	// 必須かつ未入力の場合
	if (props.required && (value == "" || value == null)) {
		errorClass.value = "input-red";
		// 上記以外の場合
	} else {
		errorClass.value = "";
	}
}
/* ---------------------------------------------------------------------------
	get:yaer、monthに分けてdatepickerに渡す
---------------------------------------------------------------------------- */
function monthFormat(val) {
	if (val == null || val == "") {
		return;
	}

	let dateArray = "";
	dateArray = val.split("/");
	monthValue.value.year = dateArray[0];
	monthValue.value.month = dateArray[1] - 1;
	return monthValue.value;
}
/* ---------------------------------------------------------------------------
	set:searchMonthに渡す際、year/monthにして渡す
---------------------------------------------------------------------------- */
function generationFormat(val) {
	let date = "";
	if (val != null) {
		let month = val.month + 1;
		month = month.toString().padStart(2, "0");
		return (date = val.year + "/" + month);
	} else {
		return (date = "");
	}
}
/* ---------------------------------------------------------------------------
	mounted
---------------------------------------------------------------------------- */
onMounted(() => {
	// 入力項目の判定
	enteredOrNotCheck(date.value);
});
</script>
